import { Inject, inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { AuthService } from '../authentication/auth.service';

export const authGuard: CanActivateFn = (route, state) => {
  const authenticationService = inject(AuthService)
  return authenticationService.isAuthenticated(route.data['role']);
};
